import { Cell } from '@table-library/react-table-library/table';
import numeral from 'numeral';
import { collectCell, getPercent } from '../../../../helpers/showDelta';

export const COLUMNS = (t) => [
    {
        label: t('search.comparison.keywordClusers.columns.keywordCluster'),
        key: 'cluster_name',
        data: 'cluster_name',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? (
                data
            ) : (
                <strong>
                    <a
                        href={`/domains/${
                            window.info.id
                        }/gsc-reports/keyword-clusters/cluster?cluster=${encodeURIComponent(data)}`}
                        className="d-inline-flex align-items-center justify-content-center"
                        rel="noreferrer"
                    >
                        {data}
                    </a>
                </strong>
            ),
    },
    {
        label: t('search.comparison.keywordClusers.columns.impressions'),
        key: 'impressions',
        data: 'impressions',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <strong>{numeral(data).format('0.0a')}</strong>,
    },
    {
        label: t('search.comparison.keywordClusers.columns.delta'),
        key: 'impressions_delta',
        data: 'impressions_delta',
        Component: Cell,
        renderCell: ({ item, csvDownload }) =>
            csvDownload
                ? getPercent(item.impressions, item.impressionsPrior)
                : collectCell(item.impressions, item.impressionsPrior),
    },
    {
        label: t('search.comparison.keywordClusers.columns.clicks'),
        key: 'clicks',
        data: 'clicks',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <strong>{numeral(data).format('0.0a')}</strong>,
    },
    {
        label: t('search.comparison.keywordClusers.columns.delta'),
        key: 'clicks_delta',
        data: 'clicks_delta',
        Component: Cell,
        renderCell: ({ item, csvDownload }) =>
            csvDownload
                ? getPercent(item.clicks, item.clicksPrior)
                : collectCell(item.clicks, item.clicksPrior),
    },
    {
        label: t('search.comparison.keywordClusers.columns.position'),
        key: 'avgPosition',
        data: 'avgPosition',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <strong>{numeral(data).format('0.0a')}</strong>,
    },
    {
        label: t('search.comparison.keywordClusers.columns.delta'),
        key: 'avgPosition_delta',
        data: 'avgPosition_delta',
        Component: Cell,
        renderCell: ({ item, csvDownload }) =>
            csvDownload
                ? getPercent(item.avgPosition, item.avgPositionPrior)
                : collectCell(item.avgPosition, item.avgPositionPrior),
    },
    {
        label: t('search.comparison.keywordClusers.columns.ctr'),
        key: 'avgCTR',
        data: 'avgCTR',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            const ctrValue = item.clicks / item.impressions;
            return csvDownload ? ctrValue : <strong>{numeral(ctrValue).format('0.00%')}</strong>;
        },
    },
    {
        label: t('search.comparison.keywordClusers.columns.delta'),
        key: 'avgCTR_delta',
        data: 'avgCTR_delta',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            const ctrValue = item.clicks / item.impressions;
            return csvDownload
                ? getPercent(ctrValue, item.avgCTRPrior)
                : collectCell(ctrValue, item.avgCTRPrior);
        },
    },
];
